export {default as path} from "./path";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-path/src/index.js
// module id = 112
// module chunks = 1